"use client";

import React from "react";
import {
  Box,
  CircularProgress,
  Typography,
  Paper,
  LinearProgress,
} from "@mui/material";
import { keyframes } from "@mui/system";

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

const Loading = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f0f2f5"
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 2,
          maxWidth: 300,
          width: "100%",
        }}
      >
        <CircularProgress size={60} thickness={4} sx={{ mb: 2 }} />
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            animation: `${pulse} 1.5s ease-in-out infinite`,
          }}
        >
          Loading...
        </Typography>
        <LinearProgress
          sx={{
            width: "100%",
            height: 8,
            borderRadius: 4,
          }}
        />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 2, textAlign: "center" }}
        >
          Please wait while we prepare your content
        </Typography>
      </Paper>
    </Box>
  );
};

export default Loading;
